export default function PrivacyPage() {
  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.header}>
          <div style={s.logo}>₹</div>
          <div>
            <div style={s.brand}>PaisaTrack</div>
            <div style={s.sub}>Privacy Policy</div>
          </div>
        </div>

        <p style={s.date}>Effective date: April 2026</p>

        <h2 style={s.h2}>1. Who we are</h2>
        <p style={s.p}>PaisaTrack is a personal expense tracking app built and operated by Vijay Kumar Bhoyar. We are not a financial institution, bank, or investment platform. We do not handle your money — only records of how you spend it.</p>

        <h2 style={s.h2}>2. What we collect</h2>
        <p style={s.p}>When you sign up and use PaisaTrack, we collect:</p>
        <ul style={s.ul}>
          <li>Your email address and name (for account creation)</li>
          <li>Expense entries you manually add: amount, category, payment mode, date, note</li>
          <li>Budget limits you set per category</li>
          <li>Household membership if you choose to share tracking with family</li>
        </ul>
        <p style={s.p}><strong>We do not collect</strong> your bank account details, UPI PIN, OTPs, SMS messages, or any payment credentials.</p>

        <h2 style={s.h2}>3. Where your data is stored</h2>
        <p style={s.p}>All your data is stored in a secure database located in Mumbai, India. Your data does not leave India. Each user's data is isolated — other users cannot access your expenses under any circumstance.</p>

        <h2 style={s.h2}>4. What we do NOT do</h2>
        <ul style={s.ul}>
          <li>We do not sell your data to anyone</li>
          <li>We do not show you ads</li>
          <li>We do not share your data with advertisers</li>
          <li>We do not use your spending data to recommend loans or insurance</li>
          <li>We do not read your SMS, access your contacts, or request unnecessary permissions</li>
        </ul>

        <h2 style={s.h2}>5. Who can see your data</h2>
        <p style={s.p}>Only you can see your individual expense entries. If you create a household, members you invite will see shared expenses. The app owner has administrative database access for technical maintenance only and will not read individual user records.</p>

        <h2 style={s.h2}>6. Google login</h2>
        <p style={s.p}>If you sign in with Google, we receive your name and email address from Google. We do not receive your Google password or any other Google account data. You can revoke this access anytime from your Google account settings.</p>

        <h2 style={s.h2}>7. Deleting your data</h2>
        <p style={s.p}>You can delete individual expense entries directly in the app. To delete your account and all data permanently, email us at vjkumarbb@gmail.com with subject "Delete my PaisaTrack account". We will process it within 7 working days.</p>

        <h2 style={s.h2}>8. Contact</h2>
        <p style={s.p}>Vijay Kumar Bhoyar<br/>vjkumarbb@gmail.com<br/>paisatrack.vijaykumarbhoyar.com</p>

        <div style={s.footer}>Your money. Your data. Your rules.</div>
      </div>
    </div>
  )
}

const s = {
  wrap:   { minHeight: '100vh', background: '#F7F4EF', padding: '1rem', fontFamily: "'DM Sans', sans-serif" },
  card:   { background: '#fff', borderRadius: 20, padding: '2rem', maxWidth: 600, margin: '0 auto', boxShadow: '0 4px 40px rgba(0,0,0,0.06)' },
  header: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 },
  logo:   { width: 44, height: 44, borderRadius: 12, background: '#1A1A2E', color: '#E8C547', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, fontWeight: 700, flexShrink: 0 },
  brand:  { fontSize: 18, fontWeight: 700, color: '#1A1A2E' },
  sub:    { fontSize: 13, color: '#888' },
  date:   { fontSize: 12, color: '#aaa', marginBottom: 24 },
  h2:     { fontSize: 16, fontWeight: 700, color: '#1A1A2E', marginTop: 24, marginBottom: 8 },
  p:      { fontSize: 14, color: '#444', lineHeight: 1.7, marginBottom: 8 },
  ul:     { fontSize: 14, color: '#444', lineHeight: 1.8, paddingLeft: 20, marginBottom: 8 },
  footer: { marginTop: 32, paddingTop: 16, borderTop: '1px solid #EEE', fontSize: 13, color: '#aaa', textAlign: 'center', fontStyle: 'italic' }
}
